import { render, staticRenderFns } from "./ModalAddExchangeRate.vue?vue&type=template&id=64b449e2&scoped=true&"
import script from "./ModalAddExchangeRate.vue?vue&type=script&lang=js&"
export * from "./ModalAddExchangeRate.vue?vue&type=script&lang=js&"
import style1 from "./ModalAddExchangeRate.vue?vue&type=style&index=1&id=64b449e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b449e2",
  null
  
)

export default component.exports